// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federkonstante/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federkonstanteDE: PageEntry = {
  id: "post.federkonstante",
  locale: "de",
  slug: "federkonstante",
  seo: {
    title: "Glossar: Federkonstante einfach erklärt | Dietz GmbH",
    description: "Die Federkonstante ist ein physikalischer Parameter, der die Steifigkeit einer Feder beschreibt. Sie gibt an, wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehne",
  },
  type: "post",
  h1: "Glossar: Federkonstante einfach erklärt",
  intro: "Die Federkonstante ist ein physikalischer Parameter, der die Steifigkeit einer Feder beschreibt. Sie gibt an, wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehnen oder zu komprimieren. Die Federkonstante wird in Newton pro Meter (N/m) gemessen. Eine höhere Federkonstante bedeutet, dass die Feder steifer ist und mehr Kraft benötigt, um sie zu dehnen oder zu komprimieren, während eine niedrigere Federkonstante auf eine weichere Feder hinweist. Die genaue Kenntnis der Federkonstante ist entscheidend für die Auslegung von Feder-Systemen in verschiedenen Anwendungen, von Automobilfahrwerken bis zu industriellen Maschinen.",
  blocks: [

  ],
};
